export default "__VITE_ASSET__XEUVnom$__"